var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 3.66683C2.40112 3.66683 2.14677 3.56147 1.95923 3.37394C1.7717 3.1864 1.66634 2.93205 1.66634 2.66683C1.66634 2.40161 1.7717 2.14726 1.95923 1.95972C2.14677 1.77219 2.40112 1.66683 2.66634 1.66683C2.93156 1.66683 3.18591 1.77219 3.37345 1.95972C3.56098 2.14726 3.66634 2.40161 3.66634 2.66683C3.66634 2.93205 3.56098 3.1864 3.37345 3.37394C3.18591 3.56147 2.93156 3.66683 2.66634 3.66683ZM13.273 6.72016L7.27301 0.720163C7.03301 0.480163 6.69967 0.333496 6.33301 0.333496H1.66634C0.926341 0.333496 0.333008 0.926829 0.333008 1.66683V6.3335C0.333008 6.70016 0.479674 7.0335 0.726341 7.2735L6.71967 13.2735C6.96634 13.5135 7.29967 13.6668 7.66634 13.6668C8.03301 13.6668 8.36634 13.5135 8.60634 13.2735L13.273 8.60683C13.5197 8.36683 13.6663 8.0335 13.6663 7.66683C13.6663 7.2935 13.513 6.96016 13.273 6.72016Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.60f75b1fdc5a532a2b1421762d2ac540.svg";
export { ForwardRef as ReactComponent };